module.exports = __webpack_public_path__ + "img/sche_pic4.febd86ff.jpg";